import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import App from './component';

const mapStateToProps = (state) => ({
  brand: state.app.brand,
  location: state.router.location,
  loggedIn: state.user.loggedIn,
  user: state.user,
  hasStrongAuthentication: state.user.hasStrongAuthentication,
  clusterSettings: state.app.clusterSettings,
});

export default withRouter(connect(mapStateToProps)(App));
